import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { useHistory } from "react-router-dom"
// offer Redux States
import {
  SA_GET_OFFERS_LISTING,
  SA_OFFER_EDIT,
  SA_OFFER_UPDATE,
} from "./actionTypes"
import {
  saOffersListingSuccess,
  saOffersListingFail,
  saEditOfferSuccess,
  saEditOfferFail,
  saUpdateOfferSuccess,
  saUpdateOfferFail,
} from "./actions"

import {
  saOffersListingApi,
  saEditOfferApi,
  saUpdateOfferApi,
} from "../../../helpers/fakebackend_helper"

function* saGetOfferListing() {
  try {
    const response = yield call(saOffersListingApi)
    if (
      response.results === undefined ||
      response.results.prod_offers.length == 0
    ) {
      throw response.msg ? response.msg : "No data found"
    }
    yield put(saOffersListingSuccess(response.results.prod_offers))
  } catch (error) {
    yield put(saOffersListingFail(error))
  }
}

function* saGetOfferDetailsById({ payload: { id } }) {
  try {
    const response = yield call(saEditOfferApi, id)
    if (response && response.status) {
      response.id = id
      yield put(saEditOfferSuccess(response.results.offer_details))
    } else {
      throw response.msg ? response.msg : "Failed to fetch offer details"
    }
  } catch (error) {
    yield put(saEditOfferFail(error))
  }
}

function* saOnUpdateOffer({ payload: { offer, history } }) {
  try {
    const response = yield call(saUpdateOfferApi, offer)
    if (response && response.status) {
      yield put(saUpdateOfferSuccess(response))
      history.push("/offers/list")
    } else {
      throw response.msg ? response.msg : "Failed to update offer"
    }
  } catch (error) {
    yield put(saUpdateOfferFail(error))
  }
}


function* saOfferSaga() {
  yield takeEvery(SA_GET_OFFERS_LISTING, saGetOfferListing)
  yield takeEvery(SA_OFFER_EDIT, saGetOfferDetailsById)
  yield takeEvery(SA_OFFER_UPDATE, saOnUpdateOffer)
}
export default saOfferSaga
